import React from "react"
import { ActionDropdown, FormCheckbox, Avatar } from 'components/common';
import { FaFolder, FaFile, FaEllipsisV, FaDownload, FaEye, FaEdit, FaTrash, FaFilePdf, FaFileWord, FaFileExcel, FaFileImage, FaUserPlus } from "react-icons/fa"
import Proptypes from "prop-types";
import { ONLYOFFICE_SUPPORTED_TYPES } from "components/app/drive/hooks/useFileIcon"

const TemplatePolicyItem = ({ item, onAction, canDelete, canRename, isSelected, onSelect }) => {
  const isFolder = item.asset_type === "folder"
  const { allow_edit_document_online, allow_assign_owner } = item?.permissions || {}
  const canOpenInOnlyOffice = !isFolder && ONLYOFFICE_SUPPORTED_TYPES.includes(item?.content_type)

  const getFileIcon = () => {
    if (isFolder) return <FaFolder className="tw-text-yellow-500 tw-mr-2" />

    const contentType = item.content_type || ""
    if (contentType.includes("pdf")) return <FaFilePdf className="tw-text-red-600 tw-mr-2" />
    if (contentType.includes("word") || contentType.includes("document")) return <FaFileWord className="tw-text-blue-600 tw-mr-2" />
    if (contentType.includes("excel") || contentType.includes("spreadsheet")) return <FaFileExcel className="tw-text-green-600 tw-mr-2" />
    if (contentType.includes("image")) return <FaFileImage className="tw-text-cyan-500 tw-mr-2" />

    return <FaFile className="tw-text-slate-400 tw-mr-2" />
  }

  const formatFileSize = (bytes) => {
    if (!bytes) return "-"
    if (bytes < 1024) return bytes + " B"
    if (bytes < 1048576) return (bytes / 1024).toFixed(2) + " KB"
    return (bytes / 1048576).toFixed(2) + " MB"
  }

  const handleRowClick = () => {
    if (isFolder) {
      onAction(item, "open-folder")
    }
  }

  const dropdownItems = [
    ...(!isFolder ? [
      { label: 'View', icon: <FaEye />, onClick: () => onAction(item, "preview") },
      ...(canOpenInOnlyOffice ? [{
        label: allow_edit_document_online ? "Edit Online (OnlyOffice)" : "View in OnlyOffice",
        icon: <FaEdit className="tw-text-green-600" />,
        onClick: () => onAction(item, "edit-online")
      }] : []),
      { divider: true },
    ] : []),
    { label: 'Download', icon: <FaDownload />, onClick: () => onAction(item, "download") },
    { divider: true },
    ...(canRename ? [
      { label: 'Rename', icon: <FaEdit />, onClick: () => onAction(item, "rename") },
    ] : []),
    ...(allow_assign_owner && !isFolder ? [
      { label: 'Assign Owner', icon: <FaUserPlus className="tw-text-blue-600" />, onClick: () => onAction(item, "assign-owner") },
    ] : []),
    ...(canDelete ? [
      { divider: true },
      { label: 'Delete', icon: <FaTrash />, danger: true, onClick: () => onAction(item, "delete") },
    ] : []),
  ]

  return (
    <tr
      onClick={handleRowClick}
      style={{ cursor: isFolder ? "pointer" : "default" }}
      className={`tw-border-b tw-border-solid tw-border-slate-100 tw-transition-colors ${
        isSelected ? "tw-bg-blue-50" : "hover:tw-bg-blue-50/60"
      }`}
    >
      <td className="tw-p-3 tw-align-middle" onClick={(e) => e.stopPropagation()}>
        <FormCheckbox
          checked={isSelected || false}
          onChange={() => onSelect && onSelect(item.id)}
        />
      </td>
      <td className="tw-p-3 tw-align-middle">
        <div className="tw-flex tw-items-center">
          {getFileIcon()}
          {canOpenInOnlyOffice ? (
            <span
              className="tw-cursor-pointer tw-font-semibold tw-text-slate-800"
              onClick={(e) => { e.stopPropagation(); onAction(item, "view-online"); }}
            >
              {item.name}
            </span>
          ) : (
            <span className="tw-font-semibold tw-text-slate-800">{item.name}</span>
          )}
        </div>
      </td>
      <td className="tw-p-3 tw-align-middle tw-text-slate-600">
        {isFolder ? "Folder" : formatFileSize(item.file_size)}
      </td>
      <td className="tw-p-3 tw-align-middle"><Avatar name={item.created_by} className="tw-mr-2" /></td>
      <td className="tw-p-3 tw-align-middle tw-text-slate-600">{item.created_date || "-"}</td>
      <td className="tw-p-3 tw-align-middle tw-text-center" onClick={(e) => e.stopPropagation()}>
        <ActionDropdown
          align="end"
          trigger={<FaEllipsisV />}
          menuWidth={230}
          items={dropdownItems}
        />
      </td>
    </tr>
  )
}

TemplatePolicyItem.propTypes = {
  item: Proptypes.object.isRequired,
  onAction: Proptypes.func.isRequired,
  canDelete: Proptypes.bool,
  canRename: Proptypes.bool,
  isSelected: Proptypes.bool,
  onSelect: Proptypes.func,
}

export default TemplatePolicyItem;
